// Format Invoice ID
import config from "../config";
import { APICore } from "./api/apiCore";
const api = new APICore();

const formatInvoiceId = (invoice) => {
  if (invoice?.frequency === "one-time" && !invoice.parent_id) {
    return "INV-" + invoice.invoice_id;
  } else {
    return (
      "INV-" +
      invoice.invoice_id +
      "-R-" +
      (invoice.recurring_invoice_id || "0001")
    );
  }
};

const hexToRgb = (hex) => {
  const aRgbHex = hex.match(/.{1,2}/g);
  return `${parseInt(aRgbHex[0], 16)}, ${parseInt(aRgbHex[1], 16)}, ${parseInt(
    aRgbHex[2],
    16
  )}`;
};

const changeTheme = (color) => {
  document.documentElement.style.setProperty("--bs-primary", color);
  document.documentElement.style.setProperty(
    "--bs-primary-rgb",
    hexToRgb(color)
  );
};
function getFaviconEl() {
  return document.getElementById("favicon");
  
}

const setMetaDescription = desc => {
  const el = document.querySelector("meta[name='description']");
  el.setAttribute('content',desc)
}




const changePageTitle = (title) => {
 
    let account = api.getAccount();
   // document.title = title+' - '+ account?.business_name;
    
  const setTitle = title?title:"Client Portal";

  if (account?.business_name) {
    document.title = setTitle+" - "+ account?.business_name;
 
  }else{
    document.title = setTitle;
  }
}
const isAchPending = (invoiceData) =>{
  if(invoiceData?.status=="pending" && !invoiceData?.partial_paid && invoiceData?.invoicePayments?.length >  0 && invoiceData?.client_payment_source_id && invoiceData?.invoicePayments[0].payment_method==='ACH' && !invoiceData?.invoicePayments[0].refunded && !invoiceData?.invoicePayments[0].confirmed && !invoiceData?.invoicePayments[0].failed ){
    return true
  } 

  return false
}


const isACHPaymentFailed = (invoiceData) =>{
  if(invoiceData?.status=="pending" && !invoiceData?.partial_paid && invoiceData?.invoicePayments?.length >  0 && invoiceData?.client_payment_source_id && invoiceData?.invoicePayments[0].payment_method==='ACH' && !invoiceData?.invoicePayments[0].refunded && !invoiceData?.invoicePayments[0].confirmed && !invoiceData?.invoicePayments[0].failed ){
    return true
  } 

  return false
}

const changeFavIcon = (icon) => {
  if(icon){
  const favicon = getFaviconEl(); // Accessing favicon element
  favicon.href  =  config.APP_IMAGE_URI + icon;
  }
}

const setDefaultFavIcon = () => {

  const favicon = getFaviconEl(); // Accessing favicon element
  favicon.href  =  config.DASHBOARD_URL + "/img/ico/favicon-32x32.png";
  
}




//by default round to 2
const roundAmount = (amount, radix= 2) => {
 // alert(amount);

 //let number = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(number)
  return amount?.toFixed(radix);
}

export default {isAchPending,changePageTitle,setMetaDescription,setDefaultFavIcon, changeFavIcon,formatInvoiceId, hexToRgb, changeTheme, roundAmount};
